import React, { useEffect, useMemo, useState } from 'react';
import { DatePicker } from '@groupby/ui-components';
import Popover from '@mui/material/Popover';
import { endOfDay, startOfDay } from 'date-fns';
import { useLocalization } from '@/localization';
import { StyledDateFilterActionContainer, StyledDateFilterContainer } from './header-date-filter.styles';
import { Button } from '@/components/button';
export const HeaderDateFilter = ({ open, anchorEl, onClose, startDate, endDate, updateFilter, }) => {
    const { formatMessage: t, getLocale } = useLocalization();
    const [start, setStartDate] = useState(startDate);
    const [end, setEndDate] = useState(endDate);
    const selectedLanguage = getLocale();
    const maxDate = useMemo(() => endOfDay(new Date()), []);
    const onChange = (dates) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
    };
    const onCancel = (e) => {
        setStartDate(startDate);
        setEndDate(endDate);
        onClose(e);
    };
    const onSave = (e) => {
        updateFilter({
            startAt: Number(startOfDay(start)),
            endAt: Number(endOfDay(end !== null && end !== void 0 ? end : start)),
        });
        onClose(e);
    };
    useEffect(() => {
        setStartDate(startDate);
        setEndDate(endDate);
    }, [
        startDate,
        endDate,
    ]);
    return (<Popover open={open} anchorEl={anchorEl} onClose={onClose} anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }} transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}>
      <StyledDateFilterContainer>
        <DatePicker selected={typeof start === 'number' ? new Date(start) : start} onChange={onChange} startDate={typeof start === 'number' ? new Date(start) : start} endDate={typeof end === 'number' ? new Date(end) : end} selectsRange inline locale={selectedLanguage} maxDate={maxDate}/>
        <StyledDateFilterActionContainer>
          <Button onClick={onCancel}>{t({ key: 'CANCEL' })}</Button>
          <Button onClick={onSave}>{t({ key: 'OK' })}</Button>
        </StyledDateFilterActionContainer>
      </StyledDateFilterContainer>
    </Popover>);
};
